module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/cinnamon_9ef22e.jpg";